import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MoneyInput from 'book-calculator/components/MoneyInput';

class BookCalculatorMoneyInput extends Component {
    constructor(props) {
        super(props);

        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.onInputClick = this.onInputClick.bind(this);
        this.onMoneyChange = this.onMoneyChange.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.unFocus = this.unFocus.bind(this);
        this.onTitleChange = this.onTitleChange.bind(this);

        this.state = {
            value: props.value,
            isChecked: props.isChecked,
            title: props.title,
            isFocused: false,
        };
    }

    setFocus() {
        this.setState({ isFocused: true });
    }

    unFocus() {
        this.setState({ isFocused: false });
    }

    onInputClick(event) {
        if (!this.state.isChecked) {
            this.onCheckboxChange();
        }
    }

    onCheckboxChange() {
        this.setState({ isChecked: !this.state.isChecked }, () =>
            this.props.onChange({
                isChecked: this.state.isChecked,
                value: this.state.value,
                title: this.state.title,
            })
        );
    }

    onMoneyChange(value) {
        this.setState({ value });
        this.props.onChange({
            isChecked: this.state.isChecked,
            value: value,
            title: this.state.title,
        });
    }

    onTitleChange(event) {
        this.setState({ title: event.target.value });
        this.props.onChange({
            isChecked: this.state.isChecked,
            value: this.state.value,
            title: event.target.value,
        });
    }

    UNSAFE_componentWillReceiveProps({ isChecked, value }) {
        this.setState({ isChecked, value });
    }

    renderTitle() {
        if (this.props.isTitleEditible) {
            return (
                <input
                    type="text"
                    className="input-text input-text--heading-h5"
                    placeholder={'Enter your title'}
                    value={this.state.title}
                    onChange={this.onTitleChange}
                    onClick={this.onInputClick}
                />
            );
        } else {
            return this.state.title;
        }
    }

    render() {
        const { description, moneyInputPlaceholder } = this.props;

        return (
            <label
                className="book-calculator-money-input"
                data-focused={this.state.isFocused ? 'true' : null}
                data-checked={this.state.isChecked ? 'true' : null}
            >
                <input
                    type="checkbox"
                    className="book-calculator-money-input__checkbox"
                    checked={this.state.isChecked}
                    onFocus={this.setFocus}
                    onBlur={this.unFocus}
                    onChange={this.onCheckboxChange}
                />
                <div className="book-calculator-money-input__title">{this.renderTitle()}</div>
                <div className="book-calculator-money-input__field">
                    <MoneyInput
                        value={this.state.value}
                        onChange={this.onMoneyChange}
                        onClick={this.onInputClick}
                        placeholder={moneyInputPlaceholder}
                    />
                </div>
                <div className="book-calculator-money-input__description">{description}</div>
            </label>
        );
    }
}

BookCalculatorMoneyInput.propTypes = {
    onChange: PropTypes.func,
    title: PropTypes.string,
    description: PropTypes.string,
    isChecked: PropTypes.bool,
    isTitleEditible: PropTypes.bool,
    moneyInputPlaceholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

BookCalculatorMoneyInput.defaultProps = {
    onChange: () => {},
    isChecked: false,
    isTitleEditible: false,
    moneyInputPlaceholder: null,
};

export default BookCalculatorMoneyInput;
